import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: theme.spacing(3),

    '& .details': {
      '&-avatar': {
        '&-container': {
          marginRight: theme.spacing(2),
        },
      },
      '&-infos-container': {
        display: 'flex',
        flexDirection: 'column',
      },
      '&-name': {
        color: theme.palette.text.primary,
        fontWeight: 'bold',
      },
      '&-area': {
        color: theme.palette.text.hint,
      },
      '&-section': {
        '&-container': {
          display: 'flex',
          flexDirection: 'column',
          margin: theme.spacing(2, 0),
        },
        '&-label': {
          fontWeight: 'bold',
          color: theme.palette.text.hint,
        },
        '&-description': {
          color: theme.palette.text.secondary,
        },
      },
    },
  },
}));

export default styles;
